module.exports = "<div>\t\n\t<app-header-nav></app-header-nav>\n\t<div class=\"m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body\">\n\t\t<app-aside-nav></app-aside-nav>\t\n\t\t<div class=\"m-grid__item m-grid__item--fluid m-wrapper\">\n\t\t\t<div class=\"m-content\">\n\t\t\t\t<router-outlet></router-outlet>\t\t\t\n\t\t\t</div>\t\t\n\t\t</div>\n\t</div>\n\t<app-footer></app-footer>\t\n</div>\n\n<app-scroll-top></app-scroll-top>"


//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/4b34a5ca2bd08993/UI/rp/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main